<template>
  <t-upper-nav-menu ref="child">
    <template #trigger>
      <button
        class="tw-block tw-opacity-50 tw-cursor-not-allowed"
        data-test-id="upper-nav-display-mode-button"
        v-tippy="{
          content:
            'Dark mode is temporarily disabled during theme migration. It will be available again soon.',
          placement: 'bottom',
        }"
      >
        <cl-icon-tabler-sun-filled />
      </button>
    </template>
    <template #title>
      <div class="tw-text-xl tw-text-center tw-font-semibold">
        {{ $t("text-block-display-mode") }}
      </div>
    </template>
    <template #content>
      <div class="tw-flex tw-justify-center">
        <div class="tw-flex tw-border tw-border-primary-grey-500 tw-rounded-md">
          <button
            v-for="displayMode in displayModes"
            :key="displayMode.testId"
            class="tw-flex tw-flex-col tw-items-center tw-p-2 tw-w-[64px] [&:not(:last-child)]:tw-border-r tw-border-primary-grey-500 tw-opacity-50 tw-cursor-not-allowed"
            :class="{
              'tw-bg-primary-grey-200':
                displayMode.theme === userPrefferedTheme,
            }"
            :data-test-id="displayMode.testId"
          >
            <component :is="displayMode.icon" />{{ $t(displayMode.label) }}
          </button>
        </div>
      </div>
    </template>
  </t-upper-nav-menu>
</template>

<script setup lang="ts">
import { ref } from "vue";
import TUpperNavMenu from "./TUpperNavMenu.vue";
import { useTheme } from "@/composables";
import { THEME } from "@/constants";
import { trackEvent } from "@/utils/track-event";

const child = ref<InstanceType<typeof TUpperNavMenu>>();

// @ts-expect-error - Temporarily disabled during theme migration
const _toggleDisplayModeMenu = () => {
  trackEvent({
    category: "Upper navigation",
    action: "display mode button clicked",
    name: "",
  });

  child.value?.toggleMenuVisibility();
};

type Theme = typeof THEME.LIGHT | typeof THEME.DARK | typeof THEME.SYSTEM;

const displayModes: {
  testId: string;
  theme: Theme;
  icon: string;
  label: string;
}[] = [
  {
    testId: "upper-nav-display-mode-light-button",
    theme: THEME.LIGHT,
    icon: "cl-icon-tabler-sun-filled",
    label: "toggle-label-light",
  },
  {
    testId: "upper-nav-display-mode-dark-button",
    theme: THEME.DARK,
    icon: "cl-icon-tabler-moon-filled",
    label: "toggle-label-dark",
  },
  {
    testId: "upper-nav-display-mode-system-button",
    theme: THEME.SYSTEM,
    icon: "cl-icon-tabler-device-desktop",
    label: "toggle-label-system",
  },
];

const { userPrefferedTheme, setUserPreferredTheme } = useTheme();

// @ts-expect-error - Temporarily disabled during theme migration
const _onDisplayModeClick = (theme: Theme) => {
  setUserPreferredTheme(theme);

  trackEvent({
    category: "Upper navigation",
    action: "display mode changed",
    name: theme,
  });
};
</script>
